<script lang="ts" setup>
import type { LinkNode } from '@laam/cms-shared';
import { LazyImage } from '../lazy-image';

interface EntityCardProps {
	data: LinkNode;
	entity: string;
}

defineProps<EntityCardProps>();
</script>
<template>
	<div
		class="rounded-xl image-box w-full !min-h-[100px] lg:!min-h-[250px] relative aspect-[0.71] bg-gray-100 overflow-clip lg:rounded-3xl"
	>
		<LazyImage
			v-if="data?.image"
			:src="data?.image"
			:alt="data.name"
			width="280"
			provider="shopify"
			class="rounded-small w-full"
		/>
		<!-- Black Overlay from bottom -->
		<div
			class="absolute top-0 z-10 left-0 right-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent flex justify-end flex-col lg:p-3xl gap-xxs from-0% via-35% via-transparent p-xl"
		>
			<h4
				v-if="data.subtitle || 'Brand Name'"
				class="mt-md max-w-full lg:text-md font-semibold text-white whitespace-pre-wrap text-left line-clamp-1 text-sm"
			>
				{{ data.subtitle || 'Brand Name' }}
			</h4>
			<div class="flex gap-xs items-end justify-end">
				<text class="text-white text-xs grow text-left line-clamp-1 lg:text-sm">
					{{ data.name.replace(/__/g, '') }}
				</text>
			</div>
		</div>
	</div>
</template>
